import { useState, useCallback } from "react";
import { executeWorkflowHandshake } from "../../Workflow-esg/Workflow_XLS_Support";

export default function DisclosureSearchController(userId, s3Key) {
  const [searchTerm, setSearchTerm] = useState("");
  const [isSearching, setIsSearching] = useState(false);
  const [disclosure_results, setDisclosureResults] = useState(null);

  const executeDisclosureSearch = useCallback(async () => {
    if (!s3Key || !searchTerm || searchTerm.trim().length < 2) return;

    // 🎯 STEP 1: Clear existing results to reset Tabs/Displays
    setDisclosureResults(null);
    setIsSearching(true);

    const payload = {
      action: "SEARCH_DISCLOSURES",
      user_id: userId, // 🎯 FIXED: Direct access to argument
      payload: {
        /* 🎯 FIXED: Using the ENV variable as requested */
        bucketName: process.env.REACT_APP_SITE_TEMPLATE_BUCKET || "esg-template-management",
        fileName: s3Key,
        searchQuery: searchTerm.trim()
      }
    };

    try {
      const response = await executeWorkflowHandshake(
        "doorman/disclosures",
        payload,
        "Disclosures"
      );

      if (response?.success && response?.data?.data) {
        setDisclosureResults(response.data.data);
      }
    } catch (err) {
      console.error("🚨 [SEARCH_FAILED]:", err.message);
    } finally {
      setIsSearching(false);
    }
  }, [userId, s3Key, searchTerm]);

  return {
    searchTerm,
    setSearchTerm,
    isSearching,
    disclosure_results,
    executeDisclosureSearch
  };
}